export default ({ color = '#757575' }) => (
  <svg width="3" height="12" viewBox="0 0 3 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="1.5" cy="2" r="1.5" fill={color} />
    <circle cx="1.5" cy="6" r="1.5" fill={color} />
    <circle cx="1.5" cy="10" r="1.5" fill={color} />
  </svg>
)
